export default __webpack_public_path__ + "static/media/img_02.4d0fbae2.jpg";